import { message } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../../services/api";
import { Content } from "./styles";
import { Modal } from "../Modal";

interface Props {
  messageToSend: string;
  file: File | null;
  data: {
    data: any[],
    columns: string[]
  } | null;
  onCancel: () => void;
  clientId: string;
  random: boolean
}
export function MessageSendCountModal({ messageToSend, file, data, onCancel, clientId, random }: Props) {
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(0);
  const [percentage, setPercentage] = useState(0);
  function generateRandom() {
    return Math.floor(Math.random() * (300000 - 0 + 1)) + 0;
  }
  async function sendMessage() {
    if (data?.data) {
      for (const [, value] of data.data.entries()) {
        let messageData = messageToSend;
        data?.columns.forEach((column) => {
          const index = messageData.indexOf(column);
          if (index !== -1) {
            messageData = messageData.replaceAll(`@${column}`, value[column])
          }
        })
        if(!value['numero']) continue;
        if (file) {
          const formData = new FormData();
          formData.append("clientId", clientId);
          formData.append("number", value['numero']);
          formData.append("message", messageData);
          formData.append("file", file);
          if(random){
            formData.append("delay", generateRandom().toString());
          }
          await api
            .post('whatsapp/message/midia', formData)
        } else {
          await api
            .post('whatsapp/message', {
              clientId,
              number: value['numero'],
              message: messageData,
              delay: random ? generateRandom() : null
            })
        }
        setTotal((prev) => prev + 1)
      }
      message.success("Mensagens adicionadas na fila de envio!")
      setTimeout(() => {
        onCancel();
      }, 5000);
    }
  }
  useEffect(() => {
    sendMessage();
    setLimit(data?.data?.length || 0)
  }, []);
  useEffect(() => {
    setPercentage(Math.ceil((total / limit) * 100));
  }, [total, limit]);
  return (
    <Modal
      cancel={onCancel}
      loading={true}
      btnTitle="Carregando"
      confirm={() => { }}
      title="Enviando mensagens"
    >
      <Content percentage={percentage}>
        <div className="parcentage-info">
          <span className="title">Enviando...</span>
          <span className="text">
            {total}/{limit}
          </span>
          <div className="percentage-bar">
            <div className="total-bar"></div>
            <div className="active-bar"></div>
          </div>
        </div>
        <div className="percentage">{percentage}%</div>
      </Content>
    </Modal>
  );
}
